import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayFileComponent } from '../../../backoffice/display-file/display-file.component';
import { IconChevronDownComponent } from '../icon-chevron-down/icon-chevron-down.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-folder-files',
  standalone: true,
  imports: [
    CommonModule,
    DisplayFileComponent,
    IconChevronDownComponent,
    TranslatePipe],
  templateUrl: './folder-files.component.html',
  styleUrl: './folder-files.component.css',
})
export class FolderFilesComponent {
  @Input() folderName!: string;
  @Input() filePaths: string[] | undefined | null = [];
  isOpen = false;

  toggleFolder() {
    this.isOpen = !this.isOpen;
  }
}
